import { useRef, useEffect, useState } from 'react';
import './About.css';

const TECH = [
  'JavaScript','Python','Java','HTML/CSS','Flask',
  'FastAPI','JavaFX','Tailwind','SQLite','Git','Pandas','NumPy',
  'Adobe Illustrator ✦'
];

function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setInView(true); obs.disconnect(); }
    }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

export default function About() {
  const [ref, inView] = useInView();

  return (
    <section className="section" id="about">
      <div className="container">
        <div className="section-label">about</div>
        <div className="about-grid" ref={ref}>
          <div className={`about-left ${inView ? 'animate-up' : ''}`}>
            <div className="profile-photo-wrap">
              <img src="/profile.jpg" alt="Kelechi Onwuka" className="profile-photo" />
            </div>
            <h2 className="section-title">Developer who<br />solves real problems.</h2>

            <div className="about-paras">
              <p>
                I'm Kelechi Onwuka, a Computer Science student at Suffolk University graduating in May 2026.
                I like building things that are actually useful, usually starting with something I personally
                needed and figuring it out from there.
              </p>
              <p>
                Outside of coding, I love reading, going on long walks, and I'm a huge foodie. I even
                co-founded a vegan food club on campus because we felt like that community was easy to
                overlook, and wanted to create a space where people could feel seen and supported.
              </p>
              <p>
                I approach my work the same way, focusing on real problems, keeping things simple,
                and making sure what I build actually works for the people using it.
              </p>
            </div>
          </div>

          <div className={`about-right ${inView ? 'animate-up' : ''}`} style={{ animationDelay: '0.15s' }}>
            <div className="terminal-card about-terminal">
              <div className="terminal-header">
                <span className="dot" style={{ background: '#FF5F57' }} />
                <span className="dot" style={{ background: '#FEBC2E' }} />
                <span className="dot" style={{ background: '#28C840' }} />
                <span className="term-label">stack.config</span>
              </div>
              <div className="about-tech-grid">
                {TECH.map((t, i) => (
                  <div
                    key={t}
                    className="tech-pill"
                    style={{ animationDelay: `${i * 0.05}s` }}
                  >
                    <span className="tech-dot">▸</span>
                    {t}
                  </div>
                ))}
              </div>
            </div>

            <div className="about-edu terminal-card">
              <div className="terminal-header">
                <span className="dot" style={{ background: '#FF5F57' }} />
                <span className="dot" style={{ background: '#FEBC2E' }} />
                <span className="dot" style={{ background: '#28C840' }} />
                <span className="term-label">education.log</span>
              </div>
              <div className="edu-body">
                <div className="edu-degree">B.S. Computer Science</div>
                <div className="edu-minor">Minor in Cybersecurity</div>
                <div className="edu-school">Suffolk University · Boston, MA</div>
                <div className="edu-date">Expected May 2026</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
